import { render } from "./Shareholders.vue?vue&type=template&id=1a4f96c6"
import script from "./Shareholders.vue?vue&type=script&lang=js"
export * from "./Shareholders.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__